/** Secret ops-console mount point. Comes from REACT_APP_ADMIN_PATH so it never lives in source. */
export const ADMIN_SLUG = process.env.REACT_APP_ADMIN_PATH || "";
export const ADMIN_BASE = ADMIN_SLUG ? `/${ADMIN_SLUG}/admin` : "/__admin_disabled__";
export const adminUrl = (sub = "") => `${ADMIN_BASE}${sub}`;
